<template>
  <nav class="navbar navbar-expand-xl navbar-dark bg-transparent fixed-top" id="mainNav">
    <div class="container">
      <a class="navbar-brand" href="/">
        <img
          src="@/assets/logo-white.png"
          height="55"
          alt="Bricks & Mortar"
          class="d-block"
          id="whiteLogo"
        />
        <img
          src="@/assets/logo-black.png"
          height="55"
          alt="Bricks & Mortar"
          class="d-none"
          id="blackLogo"
        />
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link" href="#" @click="scrollTo('slideshow')">Home</a>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link" href="#" @click="scrollTo('getToKnowUs')">Get To Know Us</a>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link" href="#" @click="scrollTo('difference')">Points of Difference</a>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link" href="#" @click="scrollTo('services')">Services</a>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link" href="#" @click="scrollTo('switchingOver')">Switching</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#" @click="scrollTo('media')">Media</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#" @click="scrollTo('testimonials')">Testimonials</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#" @click="scrollTo('blog')">Blog</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#" @click="scrollTo('contact')">Contact</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import $ from "jquery";

export default {
  name: "Nav",
  methods: {
    scrollTo(element) {
      let scrollPoint = $("#" + element).offset().top - 150;
      if (scrollPoint < 0) scrollPoint = 0;
      $("html, body").animate(
        {
          scrollTop: scrollPoint
        },
        2000
      );
    }
  }
};
</script>
